import { EInvoiceViewerSearchOptions } from '../interfaces/einvoice-viewer-search-options.interface';

export function normalizeSearchText(value: string): string {
  return value.trim().toLocaleLowerCase();
}

export function matchesSearchTexts(searchTexts: readonly string[], options: EInvoiceViewerSearchOptions): boolean {
  const normalizedQuery = normalizeSearchText(options.query);
  if (!normalizedQuery) {
    return false;
  }

  return searchTexts.some(searchText => {
    const normalizedSearchText = normalizeSearchText(searchText);
    return options.exactMatch
      ? normalizedSearchText === normalizedQuery
      : normalizedSearchText.includes(normalizedQuery);
  });
}